import { useCallback, useMemo } from 'react';
import { DATE, DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import { useAsyncFetcher } from 'reporting-data/asyncData/useAsyncFetcher';
import { isBreakdownDimensionSupportedForDataType } from 'reporting-data/lib/unifiedAnalytics';
// @ts-expect-error Untyped import
import getProperties from 'reporting-data/properties';
import { UNIFIED_DATA_TYPES } from 'reporting-data/constants/dataTypes';
// @ts-expect-error Untyped import
import dataType from 'reporting-data/properties/data-type';
// @ts-expect-error Untyped import
import { get as isUnified } from 'reporting-data/retrieve/unified/supported';
const datePropertyTypes = [DATE, DATE_TIME];
const capitalizeFirstWord = word => {
  const firstLetter = word.charAt(0);
  return firstLetter.toUpperCase() + word.substring(1);
};
const useFetchDropdownOptionsForDimensionSelector = (reportDimensions, reportDataType, deferred = false) => {
  const isBreakdownSupportedFetcher = useCallback(() => isBreakdownDimensionSupportedForDataType(reportDataType || ''), [reportDataType]);
  const canReportUseBreakdownDimensionFetch = useAsyncFetcher({
    fetcher: isBreakdownSupportedFetcher,
    deferred
  });
  deferred = deferred || UNIFIED_DATA_TYPES.includes(dataType) && isSucceeded(canReportUseBreakdownDimensionFetch);
  const fetcher = useCallback(dataTypeParam => getProperties(dataTypeParam), []);
  const resultFormatter = useCallback(res => {
    const canReportUseBreakdownDimension = isSucceeded(canReportUseBreakdownDimensionFetch) && canReportUseBreakdownDimensionFetch.data;
    const propertyMetaData = res.get(reportDataType);
    const isUnifiedReportWithNoBreakdownDimension = isUnified(reportDataType || '') && !reportDimensions.includes('breakdown');
    const formattedOptions = reportDimensions.push(...(isUnifiedReportWithNoBreakdownDimension && canReportUseBreakdownDimension ? ['breakdown'] : [])).toArray().filter(dimension => !datePropertyTypes.includes(propertyMetaData.getIn([dimension, 'type']))).map(dimension => ({
      text: capitalizeFirstWord(propertyMetaData.getIn([dimension, 'label']) || dimension),
      value: dimension
    }));
    return formattedOptions;
  }, [canReportUseBreakdownDimensionFetch, reportDataType, reportDimensions]);
  const requestArgs = useMemo(() => reportDataType, [reportDataType]);
  const dropdownFetch = useAsyncFetcher({
    resultFormatter,
    fetcher,
    requestArgs,
    deferred
  });
  if (isLoading(canReportUseBreakdownDimensionFetch) || isLoading(dropdownFetch)) {
    return {
      isLoading: true,
      dropdownOptions: []
    };
  }
  const options = isSucceeded(dropdownFetch) ? dropdownFetch.data : [];
  return {
    isLoading: false,
    dropdownOptions: options
  };
};
export default useFetchDropdownOptionsForDimensionSelector;